import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFacebook = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#1877F2"
        d="M2 3.667C2 2.747 2.746 2 3.667 2h16.666C21.253 2 22 2.746 22 3.667v16.666c0 .92-.746 1.667-1.667 1.667H3.667C2.747 22 2 21.254 2 20.333z"
      />
      <path
        fill="#fff"
        d="M18.111 12c0-3.3-2.7-6-6-6s-6 2.7-6 6c0 3 2.175 5.475 5.025 5.925v-4.2h-1.5V12h1.5v-1.35c0-1.5.9-2.325 2.25-2.325.675 0 1.35.15 1.35.15v1.5h-.75c-.75 0-.975.45-.975.9V12h1.65l-.3 1.725h-1.425V18c3-.45 5.175-3 5.175-6"
      />
    </svg>
  );
};
export default SvgFacebook;
